import styled from 'styled-components'

export {
  Count,
  HeaderActions,
  Page,
  PageEyebrow,
  PageHeader,
  PageIntro,
  PageSubtitle,
  PageTitle,
  State,
  StateText,
  StateTitle,
} from 'screens/AuthenticatedArea/UserApprovals/styled'

export const StatusTabs = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 18px;
  overflow-x: auto;

  @media (max-width: 480px) {
    flex-wrap: wrap;
    overflow-x: visible;
  }
`

export const StatusTab = styled.button`
  min-height: 42px;
  padding: 8px 18px;
  border: 1px solid ${p => p.active ? p.theme.palette.primary.main : p.theme.palette.colors.borderSoft};
  border-radius: 999px;
  background: ${p => p.active ? p.theme.palette.primary.main : p.theme.palette.colors.surfaceElevated};
  color: ${p => p.active ? p.theme.palette.primary.contrastText : p.theme.palette.colors.text};
  cursor: pointer;
  font-family: Poppins;
  font-weight: 700;
  text-transform: capitalize;
`
